angular.module('dnecom').directive('dateGreaterThan', function () {
    return {
        require: 'ngModel',
        scope: {
            compareWithValue: '=dateGreaterThan'
        },
        link: function (scope, element, attrs, ngModelController) {
            scope.$watch('compareWithValue', function(){
                ngModelController.$validate();
            }, true);

            ngModelController.$validators.greaterThan = function(modelValue, viewValue) {
                if (ngModelController.$isEmpty(modelValue) || ngModelController.$isEmpty(scope.compareWithValue)) {
                    return true;
                }

                return Date.parse(modelValue) > Date.parse(scope.compareWithValue);
            };
        }
    };
});
